/*
This doc maintain list name of all feature flags defined in split.io
Naming of feature in split should follow the structure `web_{Team Prefix}_featureName`
*/

const SPLIT_FEATURES = {
  //these are config, so please do not remove
  //begin config
  GST_VALUE: 'fe_gst_amount',
  BOYS_BRIGADE: 'fe_brow_boys_brigade',
  WEB_CONFIGURATIONS: 'web_configurations',
  SERVICE_FEES: 'fe_brow_service_fees',
  DC_CONFIG: 'fe_checkout_dcConfig',
  DC_FREE_TRIAL: 'fe_account_dc_free_trial',
  DC_FREE_TRIAL_BENEFITS: 'fe_dc_benefits',
  BUSINESS_PROFILE_INDUSTRIES: 'ef_business_profile_industries',
  WEB_INVOICE_CONFIGS: 'web_invoice_configs',
  EXTRA_LP_FLAG: 'isExtraLPInfoOn',
  SEC_LANDING_PAGE: 'fe_sec_campaign',
  VOUCHER_WALLET_SORTING: 'fe_voucher_wallet_sorting',
  PAYMENT_SDK_APPLE_GOOGLE_PAY_ENABLED: 'fe_checkout_apple_google_pay',
  PAYMENT_GATEWAY_DOWN: 'fe_pricing_payment_gateway_down',
  GOOGLE_PAY_3DS: 'fe_pricing_payment_google_pay_3ds_only_web', // use in the payment sdk
  //end config
  //begin backend experiment
  BACKEND_EXP_KEY: 'web_brow_backend_driven_exp',
  //end ackend experiment
  GIFT_ENTRY_POINT: 'fe_pay_gift_entry_point', //
  RATINGS: 'fe_brow_web_ratings', //grocery-discovery
  ES_ORDER_DURATION: 'fe_brow_es_order_duration', //grocery-discovery
  POA_FIRST_MILESTONE: 'fe_poa_mst_1_enabled', //grocery-cart
  POA_FIRST_POINT_ONE_MILESTONE: 'fe_poa_mst_1_point_1_enabled', //grocery-cart
  CHECKOUT_VOUCHER_REMOVAL_BANNER: 'fe_checkout_voucher_removal_banner', //grocery-cart
  GMC_ENABLING: 'fe_checkout_gmc_isEnabled', //grocery-cart
  SMART_RECOMM: 'web_brow_smart_recom', //grocery-search
  SHELF_LIFE: 'fe_brow_shelf_life', //grocery-discovery
  DATASCIENCE_ENABLED: 'fe_brow_datascience', //grocery-discovery
  OOS_REDUCED_QUANTITY: 'fe_checkout_oos_isReducedQuantityEnabled', //grocery-cart
  COMPLEMENTARY_SWIMLANE_ENABLED: 'fe_complementary_swimlane_enabled', //grocery-discovery
  CART_GST_LABEL: 'cart_gst_label', //grocery-cart
  PURCHASE_ORDER_AMENDMENT_HOME_ENABLED: 'lifestyle_home_poa', //grocery-discovery
  PURCHASE_ORDER_AMENDMENT_ENABLED: 'fe_poa_mst_1_enabled', //grocery-discovery
  PUBLITAS: 'fe_publitas', //grocery-discovery
  CART_FILLER: 'fe_gsr_cartfiller', //grocery-search
  PROMO_PRIORITY: 'fe_dis_promo_priority', //grocery-discovery
  CATEGORY_COLLECTION_NAVIGATION: 'fe_gsr_catnav', //grocery-search
  CAT_BUBBLE_ENABLED: 'fe_dis_catbubog', //grocery-discovery
  SWIMLANE_WITH_BANNER_ENABLED: 'dis_swimbanner', //grocery-discovery
  SWIMLANE_COUNTDOWN_ENABLED: 'fe_dis_countdown', //grocery-discovery
  PRODUCT_CAMPAIGN_LABEL_ENABLED: 'fe_dis_product_campaign_label', //grocery-discovery
  SWA_SWIMLANE_ENABLED: 'fe_brow_promobanner', //grocery-discovery
  ALGOLIA_PERSONALISATION: 'fe_gsr_algoliapersonalisation', //grocery-search
  HEALTHIER_CHOICE_INFO_ENABLED: 'fe_hpb_healthier_choice', //grocery-discovery
  CHECKOUT_DELIVERY_PREF_ENABLED: 'fe_delivery_preference_enabled', //grocery-cart
  CHECKOUT_DELIVERY_PREF_FFS: 'fe_delivery_preference_ffs', //grocery-cart
  CHECKOUT_DELIVERY_PREF_PFC: 'fe_delivery_preference_pfc', //grocery-cart
  CART_ALCOHOL_DISCLAIMER: 'fe_cart_alcohol_disclaimer', //grocery-cart
  CART_ALCOHOL_DISCLAIMER_CATEGORY_IDS: 'fe_cart_alcohol_disclaimer_ids', //grocery-cart
  FIX_EMPTY_SEARCHPAGE: 'fe_gsr_fix_empty_search_result_page', //grocery-search
  FE_SEGMENT_BRAND_MAIN_CLICKED: 'fe_seg_brand_main_clicked', //grocery-search
  FE_SEGMENT_PROMO_MAIN_CLICKED: 'fe_seg_promo_main_clicked', //grocery-search
  FE_SEGMENT_SEARCH_COMPLETED: 'fe_seg_search_completed', //grocery-search
  FE_SEGMENT_CATEGORY_MAIN_CLICKED: 'fe_seg_category_main_clicked', //grocery-search
  NO_SWITCH_PFC: 'fe_dis_no_switch_pfc', //grocery-discovery
  FE_DISABLE_ORIGINAL_STORE_BULK_THRESHOLD_CHECK:
    'fe_cart_disable_original_store_bulk_threshold_check', //grocery-cart
  FE_SEGMENT_ACCOUNT_CREATED: 'fe_seg_account_created', //grocery-search
  FE_SEGMENT_IDENTIFY_CALLS: 'fe_seg_identify_calls', //grocery-search
  FE_SEGMENT_APP_BROWSER_OPENED: 'fe_seg_appbrowser_opened', //grocery-search
  FE_DY_HEADERS_INCLUDE: 'fe_dy_headers_include', //grocery-search
  FE_SEGMENT_OG_B2C_CHECKOUT_PLACE_ORDER_CLICKED:
    'fe_seg_og_b2c_checkout_place_order_clicked', //grocery-cart
  FE_SEGMENT_OG_B2B_CHECKOUT_PLACE_ORDER_CLICKED:
    'fe_seg_og_b2b_checkout_place_order_clicked', //grocery-cart
  FE_SEGMENT_OG_CHECKOUT_AMENDMENT_CLICKED: 'fe_seg_checkout_amendment_clicked', //grocery-cart
  FE_GSR_MIGRATION_WTYL: 'fe_gsr_migration_wtyl', //grocery-search
  FE_POA_DELETED_ADDRESS_HANDLING:
    'fe_checkout_poa_deleted_address_handling_enabled', //grocery-cart
  FE_GT_REC_WTYL: 'fe_gt_rec_wtyl', //grocery-search
  FE_GT_REC_FBT: 'fe_gt_rec_fbt', //grocery-search
  FE_GT_REC_CAT: 'fe_gt_rec_category', //grocery-search
  FE_GT_REC_PDBN: 'fe_gt_rec_pdbn', //grocery-search
  FE_GT_REC_WS: 'fe_gt_rec_ws', //grocery-search
  FE_GT_REC_R4U: 'fe_gt_rec_r4u', //grocery-search
  FE_DIS_PDP_VOUCHERS: 'fe_dis_pdp_vouchers', //grocery-discovery
  FE_DIS_MARKETING_LEAD_GEN: 'fe_dis_marketing_lead_gen', //grocery-discovery
  FE_CART_VOUCHER_WOBBLER: 'fe_cart_voucher_wobbler', // grocery-cart
  FE_ZERO_SEARCH_SWIMLANE_ENABLED: 'fe_zero_search_swimlane_enabled', //grocery-cart

  FF_HIDE_ORDER_FEEDBACK: 'ff_hide_order_feedback', //fullfillment
  FE_DELIVERY_NOTES: 'fe_od_deliveryNotes_enabled', //fullfillment
  B2B_QUICKBUY: 'fe_quickbuy', //fullfillment
  FE_RETURN_VOUCHER_ENABLED: 'fe_return_voucher_enabled', //fullfillment
  FE_CITRUS_TRACKING_V2: 'fe_citrus_tracking_v2', //grocery-cart
  FE_REC_BEST_SELLER: 'fe_gt_rec_bs', //grocery-search
  FE_REC_WHATS_HOT_NOW: 'fe_gt_rec_whn', //grocery-search
  FE_REC_NEW_EXCLUSIVE: 'fe_gt_rec_ne', //grocery-search
  FE_REC_THIS_WEEK_FRESH_PICK: 'fe_gt_rec_wfp', //grocery-search
  FE_REC_TAG: 'fe_gt_rec_tag', //grocery-search
  FE_CART_PAST_PURCHASE_V2_API: 'fe_cart_past_purchase_v2_api', //gorcery-cart
  DEPRECATE_PRODUCT_BULK_ORDER_THRESHOLD:
    'fe_cart_deprecate_product_bulk_order_threshold', //grocery-cart
  WEB_FULL_WITHDRAWAL_REQUEST_FORM: 'web_full_withdrawal_request_form', //loyalty
  FE_DEDUPE_CHECKOUT_CALL: 'fe_dedupe_checkout_call', //grocery-cart
  FE_DIS_SPLIT_TRACKING: 'fe_dis_split_tracking', //grocery-discovery'
  FE_SEARCH_DROPDOWN: 'fe_gt_search_dropdown', //grocery-search
  DIS_VOUCHER_IMAGE_SWIMLANE: 'dis_voucher_image_swimlane', //grocery-discovery
  FE_INCETIVE_SLOTS: 'ff_fe_incentive_slots', // fullfillment
  FE_VOUCHER_SWIMLANE_FOR_NON_LOGGED_IN:
    'fe_voucher_swimlane_for_non_logged_in_users',
  RMN_OSMOS_ENABLED: 'web_rmn_osmos_enabled',
  LEAP_CDP_RELEASE_ONE: `leap_cdp_release_1`, // leap: foundational analytics event, app opened, user logged in/out, product atc, product viewed, product clicked, page viewed
  LEAP_CDP_RELEASE_TWO: `leap_cdp_release_2`, // leap: challenges, promotion collections, search, scan at door
  LEAP_CDP_RELEASE_THREE: `leap_cdp_release_3`, // leap: voucher view, click, applied, see all button click for product swimlane, voucher swimlane, promo collection
  LEAP_CDP_RELEASE_FOUR: 'leap_cdp_release_4', // leap: view account page, account page clicked at continue button, enhancment UTM parameters v2
  LEAP_CDP_RELEASE_FIVE: 'leap_cdp_release_5', // leap: enhancement UTM parameters v2, voucher add button click, Product remove from cart
  LEAP_CDP_RELEASE_SIX: 'leap_cdp_release_6', // leap: Popup clicked, Popup viewed, filter applied event, Popup clicked, Popup viewed, Category click, Brand click
  FE_PDM_SEARCH_LIST_SWITCH: 'fe_pdm_search_list_switch', // PDM
  FE_DYNAMICS_MYINFO: 'fe_dynamics_myinfo',
  FE_ENGM_GET_APP_MENU: 'fe_engm_get_app_menu', // engagement
  FE_ENGM_FIND_SIMILAR_BUTTON_CLICKED: 'fe_engm_find_similar_button_clicked', // engagement
  FE_DYNAMICS_PERSONA_API_MIGRATION: 'dynamics_persona-api-migration',
  PRDM_GOOGLE_SEARCH_ECOMMERCE: 'prdm_google_search_ecommerce',
  PMT_AUTO_APPLY_GENERATION_DISCOUNT: 'pmt_auto_apply_generation_discount',
  FE_CART_CAMPAIGN_LABEL: 'fe_cart_campaign_lbl',
  FE_DYNAMICS_SOCIAL_ERR: 'dynamics_social_error',
  FE_EGV_CHIP_FILTER: 'fe_egv_chip_filter',
  FF_POA_CONTENT: 'ff_poa_content', // fullfillment
  FE_JOURNEY_NEW_SELLER_INFO: 'fe_journey_new_seller_info',
  FE_PINELABS_EGV_PORTAL: 'fe_pinelabs_egv_portal', // pricing
  FE_GRANULAR_PREFERENCE_MANAGEMENT: 'fe_dynamics_granunlar_preference_page',
  FE_OMNI_ALERT_BAR: 'fe_omni_alert_bar',
  FE_INFANT_FORMULA_DESC: 'fe_infant_formula_desc',
  FE_INVALID_ADDRESS_HANDLING: 'fe_cart_invld_adrs', // pricing-cart
  FE_DYNAMICS_DIGITAL_CLUB_ANNUAL_MEMBERSHIP:
    'dynamics_digital_club_annual_membership',
  FE_DYNAMICS_DIGITAL_CLUB_ANNUAL_MEMBERSHIP_tracking:
    'dynamics_annual_dc_tracking',
  FE_JOURNEY_FILTER_COUNT: 'fe_journey_filter_count',
  /**
   * Beverage Container Return Scheme (BCRS) feature flag
   * https://ntuclink.atlassian.net/browse/DPD-225
   */
  FE_BCRS: 'fe_bcrs',
  FE_B2B_MIGRATION: 'fe_b2b_migration',
  FE_EV_VOUCHER_CONTROL: 'fe_ev_voucher_control',
}

module.exports = {
  SPLIT_FEATURES,
}
